<template>
	<div grey-back full-height class="print_field">

		<v-toolbar flat fixed norightpadding>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Print Field</v-toolbar-title>

		    <v-spacer></v-spacer>

			<v-btn flat @click="fn_resetFieldContent">Reset</v-btn>

		    <!-- <v-btn round-borders outline @click="fn_checkValidations">save</v-btn> -->

		    <!-- <v-btn icon @click="fn_getBottomMenu">
		      	<v-icon>more_vert</v-icon>
		    </v-btn> -->
		</v-toolbar>

		<v-form class="form-element hasToolbar hasFooter grey-back">

			<v-layout wrap class="form_wrapper" white-background padding-top-ten>
				<v-flex xs12 sm12 md12 form-item>
	               <v-text-field  v-model="Form.name" label="Name" placeholder=" " v-validate="'required'" :error-messages="errors.collect('name')" data-vv-name="name" :disabled="disableName" required></v-text-field>
	            </v-flex>
			</v-layout>

			<v-layout wrap white-background margin-top-ten>
				<v-card flat full-width>
	                <v-subheader>	
	                    Content
	                    <v-spacer></v-spacer>
	                    <!-- <v-btn color="primary" flat icon @click="fn_preview">
	                    	<v-icon color="primary">visibility</v-icon>
	                    </v-btn> -->
	                    <v-btn color="primary" flat icon @click="fn_openDialogQuill">
	                    	{{!content ? 'Add' : 'Edit'}}
	                    </v-btn>
	                </v-subheader>
	                <v-divider></v-divider>

	                <v-card-text class="print-field-content" v-html="content" v-if="content"></v-card-text>
	            </v-card>
			</v-layout>

			<v-layout wrap white-background margin-top-ten v-if="previewContent">
				<v-card flat full-width>
	                <v-subheader class="pr-0">
						Preview
						<v-spacer></v-spacer>
						<v-btn color="primary" flat @click="fn_editBusinessDetails" v-if="Form.name == 'Header'">Edit Business Details</v-btn>
					</v-subheader>
	                <v-divider></v-divider>
	                <v-card-text class="print-field-content" v-html="previewContent"></v-card-text>
	            </v-card>
			</v-layout>

			<div style="position:fixed;bottom:0" full-width>
				<v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Save</v-btn>
			</div>

		</v-form>

		<!-- <v-btn flat color="primary" style="position:fixed;bottom:0;background:#fff;right:0" nomargin @click="$parent.fn_preview(content)"><v-icon color="primary" left>visibility</v-icon>Preview</v-btn> -->

		<!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>
	    <dialog-quill ref="ref_dialogQuill" :saveContent="fn_saveContent"></dialog-quill>
	    <dialog-signature ref="ref_dialogSignature" :embedSignature="fn_embedSignature"></dialog-signature>
	    <dialog-bank-details ref="ref_dialogBankDetails"></dialog-bank-details>

	    <v-bottom-sheet v-model="previewSheet">
            <v-card>
                <v-card-title primary-title>
                  Content Preview
                  <v-spacer></v-spacer>
                  <v-icon v-ripple @click="previewSheet=false">close</v-icon>
                </v-card-title>
                <v-card-text class="content-preview">
                    <div v-html="previewContent"></div>
                </v-card-text>
            </v-card>
        </v-bottom-sheet>

	</div>
</template>

<script>
const menuItem = require('../../config.js').configs.menuItem;
const dialogjs =  require('../masters/forms/dialog').dialogjs;

import dialogDiscard from '../dialogs/dialog_discard'
import dialogQuill from './dialogs/dialog_quill'
import dialogSignature from './dialogs/dialog_signature'
import dialogBankDetails from './dialogs/dialog_bank_details'

	export default{
		data(){
			return{
				Form:{
					"fieldId":null,
					"name":null,
					"fieldType":null,
					"isRequired":null,
					"additionalData":{"content":null},
					"isSystem":0,
					"groupTypeId":102,
					"parentId":null,
					"isParent":false
				},
				loading:false,
				backButtonPress: false,
				dialogStorageId:null,
				discardChanges:false,
				bottomSheet:false,
				disableName:false,
				content:'',
				previewSheet:false,
				FormCopy:null,
				previewContent:null,
				defaultContent:null
			}
		},
		components:{
			'dialog-discard': dialogDiscard,
			'dialog-quill': dialogQuill,
			'dialog-signature': dialogSignature,
			'dialog-bank-details': dialogBankDetails
		},
		methods:{

			fn_resetFieldContent: function(){
				this.content = this.defaultContent ? this.defaultContent : this.Form.additionalData.defaultContent;
				this.$refs['ref_dialogQuill'].content = this.content;
				this.fn_preview();
			},

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard');
			},

			fn_openDialogQuill: function(){
				this.$refs['ref_dialogQuill'].content = this.content;
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogQuill');
			},

			fn_openDialogSignature: function(){
				this.fn_openDialogWeb('web', 'Signature', 'ref_dialogSignature');
			},

			fn_openDialogBankDetails: function(){
				this.fn_openDialogWeb('web', 'BankDetails', 'ref_dialogBankDetails');
			},

			fn_saveContent: function(content){
				this.content = content;
				this.fn_preview();
	            this.fn_closeDialog();
	            if(this.$route.query && (this.$route.query.dialog || this.$route.query.signature)){
	                this.fn_checkValidations();
	            }
	            // let self = this;
	            // setTimeout(function(){
	            // 	self.Form.content = content;
	            // 	if(self.$route.query && self.$route.query.dialog){
		           //      self.fn_checkValidations();
		           //  }
	            // },300);
	        },

			fn_preview: function(content, fromEditor){
				let printContent = fromEditor ? content : this.content;
	            if(this.$root.CurrentBusiness){
	                this.previewContent =  printContent.split('{{BusinessName}}').join(this.$root.CurrentBusiness.BusinessName ? this.$root.CurrentBusiness.BusinessName : '');
	                this.previewContent =  this.previewContent.split('{{BusinessAddress}}').join(this.$root.CurrentBusiness.Address ? this.$root.CurrentBusiness.Address : '');
	                this.previewContent =  this.previewContent.split('{{BusinessState}}').join(this.$root.CurrentBusiness.State ? this.$root.CurrentBusiness.State : '');
	                this.previewContent =  this.previewContent.split('{{GSTIN}}').join(this.$root.CurrentBusiness.GSTNumber ? this.$root.CurrentBusiness.GSTNumber : '');
					// this.previewContent =  printContent.replaceAll('{{BusinessName}}', this.$root.CurrentBusiness.BusinessName ? this.$root.CurrentBusiness.BusinessName : '');
	                // this.previewContent =  this.previewContent.replaceAll('{{BusinessAddress}}', this.$root.CurrentBusiness.Address ? this.$root.CurrentBusiness.Address : '')
	                // this.previewContent =  this.previewContent.replaceAll('{{BusinessState}}', this.$root.CurrentBusiness.State ? this.$root.CurrentBusiness.State : '');
	                // this.previewContent =  this.previewContent.replaceAll('{{GSTIN}}', this.$root.CurrentBusiness.GSTNumber ? this.$root.CurrentBusiness.GSTNumber : '');
	            }
	            fromEditor ? this.previewSheet = true : '';
	        },

			fn_editBusinessDetails: function(){
				this.$router.push({path:'/registration/business/'+this.$root.CurrentBusiness.BusinessID+'/edit'});
			},

			fn_draftAction: function(){
				this.fn_closeDialog()
				this.discardChanges = true;
				this.fn_goBack();
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialog: function(type){
				dialogjs.fn_checkAndCloseOpenDialogs(this);

				// if(this.$route.query.signature && type!='savedirect'){
				// 	this.discardChanges = true;
				// 	let self = this;
				// 	setTimeout(function(){
				// 		self.fn_goBack();
				// 	},300);
				// }
			},

			fn_embedSignature: function(dataUrl, isUploadSign){
            	// this.$refs['ref_dialogQuill'].fn_embedSign(dataUrl);
            	// this.fn_closeDialog();

            	!isUploadSign ? this.fn_closeDialog() : '';

            	this.content = "<p><strong>For {{BusinessName}}</strong></p><p><br></p><p><img src="+dataUrl+"></p><p><br></p><p><br></p><p>_____________________________</p><p>Authorised Signatory</p>";

            	this.$refs['ref_dialogQuill'].content = this.content;

	            if(this.$route.query && this.$route.query.signature){
	                this.fn_checkValidations();
	            }

				this.fn_preview();
			},

			// fn_getBottomMenu: function (tagId) {
			// 	var bottomMenu = {"BottomMenu": [menuItem.save, menuItem.reset, menuItem.help]};
			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_checkValidations: function(){
				var self = this;
			    this.$validator.validateAll().then((result) => {
			        if (result) {
			        	// if(!this.content){
			        	// 	this.showToast("Add Content");
			        	// 	return;
			        	// }
			        	this.fn_post();
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			        self.loading = false;
			    });
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('Field', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				          let status = JSON.parse(response);
				          if(status) {
				          	self.fn_cleanUp();
				          }
				          else {
				          	self.showToast("Already exists with this name");
				          }
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_get: function(itemId){
				var self = this;
				this.getData('Field', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							self.Form = JSON.parse(response);
							self.Form.additionalData = JSON.parse(self.Form.additionalData);
							let dcontent = null;
							if(self.Form.additionalData){
								dcontent = self.Form.additionalData.defaultContent ? self.Form.additionalData.defaultContent : null;
							}
							
							if(self.Form.additionalData && self.Form.additionalData.content){
								self.content = self.Form.additionalData.content;
							}
							else{
								self.Form.additionalData = {};	
								self.Form.additionalData.content = '';
								if(dcontent){
									self.Form.additionalData.defaultContent = dcontent;
								}
								// if(!self.Form.additionalData || (self.Form.additionalData && !self.Form.additionalData.defaultContent)){
								// 	self.Form.additionalData = {};	
								// 	self.Form.additionalData.content = '';
								// }
							}

							// saving default content to reset print field
							if(self.Form.additionalData.defaultContent){
								self.defaultContent = self.Form.additionalData.defaultContent;
							}
							else{
								self.defaultContent = self.Form.additionalData.content;
							}
							// self.content = self.Form.additionalData && self.Form.additionalData.content ?  self.Form.additionalData.content : '';
							self.FormCopy = JSON.parse(JSON.stringify(self.Form));
							self.fn_preview();

							self.$route.query.dialog && self.Form.name != "Header" ? self.fn_openDialogQuill() : '';

							// self.$route.query.signature ? self.fn_openDialogSignature() : '';
							self.$route.query.signature ? self.fn_openDialogQuill() : '';
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_cleanUp: function () {
				// if(this.$route.query.ls){
				// 	let data = {};
				// 	data.type = 'printTemplate';
				// 	data.id = this.Form.printTemplateId;
				// 	data.name = this.Form.name;
				// 	localStorage.setItem('newItem', JSON.stringify(data));
				// 	localStorage.setItem('closeDialog', 1);
				// }

				this.discardChanges = true;
	          	this.$router.go(-1);
			},

			fn_post: function(){
				// !this.Form.fieldId ? this.Form.fieldId = this.guid() : '';
				if(!this.Form.fieldId){
					this.Form.fieldId = this.guid();
					this.Form.createdDate = new Date();
				}

				this.Form.modifiedDate = new Date();
				
				this.Form.name = this.Form.name.trim();
				this.Form.fieldType = 'print';
				this.Form.additionalData = {};
				this.Form.additionalData.content = null;
				this.Form.additionalData.content = this.content;
				this.Form.additionalData.defaultContent = this.defaultContent ? this.defaultContent : null;
				this.Form.additionalData = JSON.stringify(this.Form.additionalData);
				// this.Form.parentId = this.$route.query && this.$route.query.parentId ? this.$route.query.parentId : null;
				console.log(this.Form);
				this.fn_saveLocal(this.Form);
			},

			fn_clearForm: function(){
				this.Form = {	
								"fieldId":null, 
								"name":null,
								"fieldType":null,
								"isRequired":null,
								"additionalData":{"content":''},
								"isSystem":0,
								"groupTypeId":102,
								"parentId":null,
								"isParent":false,
								"content":''
							};
				// this.content = '';
				this.$validator.reset();
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use

				this.backButtonPress = false;
				
				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
			},

			fn_resetForm: function () {
				this.fn_clearForm();
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){
			var self = this;

			console.log("abcdj");

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.dialogStorageId = 'dialog_'+this.formId;
				this.disableName = JSON.parse(this.$route.query.disableName);
			}

			if(this.$route.query && this.$route.query.parentId){
				this.Form.parentId = this.$route.query.parentId;
			}

			window.js_globals.fn_onBackPress = this.fn_goBack;
			// window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
	        window.js_globals.fn_uploadResponse = this.$refs['ref_dialogQuill'].fn_uploadResponse;

			this.fn_showWebView();
		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {

		  		let itemId = null;

		  		//edit from display view 
		  		// if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
				// 	itemId = from.params.tagId;
				// }

				//edit from list view
				if(to.params && to.params.tagId){
		  			itemId = to.params.tagId;
		  		}
		  		// else if((from.name=='printFieldItems' || from.name=='invoicePreviewSettings') && (to.params && to.params.tagId)){
		  		// 	itemId = to.params.tagId;
		  		// }

		  		if(itemId){
		  			vm.fn_get(itemId);
		  		}
		  		else{
		  			vm.FormCopy = JSON.parse(JSON.stringify(vm.Form));
		  		}
		  	})
		},
	    beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(this.bottomSheet || this.previewSheet){
				this.bottomSheet = false;
				this.previewSheet = false;
				next(false);
			}
			else if(dialogData && dialogData.length){

				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);

					if(this.$route.query.signature){
						next();	
					}
					else{
						next(false);	
					}
					
				}
				else{
					next(true);
				}
			}
			else{
				if(((this.FormCopy.Name != this.Form.Name) || (this.FormCopy.additionalData.content != this.content)) && !this.discardChanges){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					next();	
				}
				
			}
	    }
	}

</script>

<style>
.content-preview p{
    margin:0;
}
.print-field-content img{
	width: 100%;
	max-width: 120px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/print_fields/form.vue